var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 23 0)",
    fill: "white",
    stroke: "#D3DCEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50002 15.2306H9.36196C9.36077 15.1484 9.35976 15.0583 9.35891 14.9612C9.35468 14.4793 9.35427 13.8138 9.3562 13.0764C9.35955 11.799 9.36992 10.301 9.37979 9.15625H7.15478L4.50002 12.5954V15.2306Z",
    stroke: "#7C8092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95868 12.5547H4.99994",
    stroke: "#7C8092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8761 15.7934C10.8232 15.6347 10.854 9.865 10.8761 7H20V15.7934",
    stroke: "#7C8092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.7227H10.375",
    stroke: "#7C8092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6075 15.8608C15.6075 16.388 16.0348 16.8153 16.562 16.8153C17.0892 16.8153 17.5165 16.388 17.5165 15.8608C17.5165 15.3336 17.0892 14.9062 16.562 14.9062C16.0348 14.9062 15.6075 15.3336 15.6075 15.8608Z",
    fill: "white",
    stroke: "#7C8092"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42576 15.8608C5.42576 16.388 5.85312 16.8153 6.3803 16.8153C6.90748 16.8153 7.33484 16.388 7.33484 15.8608C7.33484 15.3336 6.90748 14.9062 6.3803 14.9062C5.85312 14.9062 5.42576 15.3336 5.42576 15.8608Z",
    fill: "white",
    stroke: "#7C8092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 8.71484L13.0937 10.7852L15.1641 12.8555",
    stroke: "#7C8092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0937 10.7852H17.752",
    stroke: "#7C8092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/check_out.e0c59a0fe2667cbb9c771ace50faf1ca.svg";
export { ForwardRef as ReactComponent };